/* WKOŁO – karta produktu: książka 3D (przeciągnij, aby obrócić; Przód / Grzbiet / Tył)
   i „Zajrzyj do środka” – fragment PDF w czytniku z kartkowaniem (PDF.js ładowany dopiero po kliknięciu),
   „Posłuchaj fragmentu” – przycisk sam odtwarza MP3 (czas i pasek postępu w przycisku),
   opis: parametry → „Szczegóły książki” pod opisem, spis treści i FAQ zwinięte, ramka z fragmentami ukryta.
   Z tych samych części korzysta okienko podglądu na półkach strony głównej (window.wkKsiazka, wkolo-regal.js). */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 749px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';

  /* ---------- książka 3D ---------- */

  var VIEWS = { front: 22, spine: 78, back: 158 };

  function initBook(root) {
    if (root.__wk) return;
    root.__wk = true;
    var book = root.querySelector('.wk-k3d__book');
    var scene = root.querySelector('.wk-k3d__scene');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-view]'));
    var w = parseFloat(root.style.getPropertyValue('--w')) || 176;
    var h = parseFloat(root.style.getPropertyValue('--h')) || 250;
    var t = parseFloat(root.style.getPropertyValue('--t')) || 26;
    var ry = VIEWS.front;

    function fit() {
      if (!root.isConnected) return;    // okienko podglądu podmienia książkę przy każdym otwarciu
      var rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      var avail = root.clientWidth - 3.2 * rem;
      var maxH = (MOBILE.matches ? 36 : 46) * rem;
      if (root.closest('.wk-pv')) {
        // okienko podglądu: książka, przyciski widoku i „Zajrzyj / Posłuchaj” mieszczą się w wysokości okna
        maxH = MOBILE.matches ? 26 * rem : Math.max(22 * rem, Math.min(44 * rem, window.innerHeight * 0.9 - 32 * rem));
      } else if (!MOBILE.matches) {
        // przyklejona książka + przyciski muszą się zmieścić między menu a paskiem „Dodaj do koszyka” motywu
        var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 96;
        var atc = document.querySelector('.sticky-atc-bar');
        var atcH = atc ? atc.offsetHeight : 0;
        maxH = Math.max(22 * rem, Math.min(maxH, window.innerHeight - header - atcH - 25 * rem));   // 25rem = odstępy, przyciski widoku i „Zajrzyj / Posłuchaj”
      }
      var s = Math.min((avail * 0.78) / (w + t * 1.4), maxH / h);
      root.style.setProperty('--s', s.toFixed(3) + 'px');
    }
    function set(deg, view) {
      ry = deg;
      book.style.setProperty('--ry', deg + 'deg');
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-view') === view ? 'true' : 'false'); });
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-view');
        // obrót najkrótszą drogą do wybranego widoku
        var target = VIEWS[v], turns = Math.round((ry - target) / 360);
        set(target + turns * 360, v);
      });
    });

    // przeciąganie (mysz i palec)
    var x0 = null, start = 0, moved = false;
    scene.addEventListener('pointerdown', function (e) {
      x0 = e.clientX; start = ry; moved = false;
      root.classList.add('is-dragging');
      scene.setPointerCapture(e.pointerId);
    });
    scene.addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      if (Math.abs(dx) > 3) moved = true;
      set(start + dx * 0.6, null);
    });
    function end() {
      if (x0 === null) return;
      x0 = null;
      root.classList.remove('is-dragging');
      var n = ((ry % 360) + 360) % 360;
      var near = n < 50 || n > 330 ? 'front' : n < 120 ? 'spine' : n < 240 ? 'back' : null;
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-view') === near ? 'true' : 'false'); });
    }
    scene.addEventListener('pointerup', end);
    scene.addEventListener('pointercancel', end);
    scene.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') set(ry - 30, null);
      if (e.key === 'ArrowRight') set(ry + 30, null);
    });

    fit();
    window.addEventListener('resize', fit);
    // krótka zachęta: książka lekko się obraca po wczytaniu
    if (!REDUCED) {
      set(-8, null);
      setTimeout(function () { set(VIEWS.front, 'front'); }, 350);
    } else {
      set(VIEWS.front, 'front');
    }
  }

  /* ---------- czytnik fragmentu ---------- */

  var reader = null, state = null, pdfjsReady = null;

  function loadPdfjs() {
    if (pdfjsReady) return pdfjsReady;
    pdfjsReady = new Promise(function (res, rej) {
      if (window.pdfjsLib) return res(window.pdfjsLib);
      var s = document.createElement('script');
      s.src = PDFJS + 'pdf.min.js';
      s.onload = function () {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS + 'pdf.worker.min.js';
        res(window.pdfjsLib);
      };
      s.onerror = rej;
      document.head.appendChild(s);
    });
    return pdfjsReady;
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function ensureReader() {
    if (reader) return reader;
    reader = el('div', 'wk-reader');
    reader.hidden = true;
    reader.setAttribute('role', 'dialog');
    reader.setAttribute('aria-modal', 'true');
    reader.setAttribute('aria-label', 'Fragment książki');
    reader.innerHTML =
      '<div class="wk-reader__bar"><p class="wk-reader__title"></p>' +
      '<a class="wk-reader__dl" target="_blank" rel="noopener">Pobierz PDF</a>' +
      '<button type="button" class="wk-reader__close" aria-label="Zamknij">×</button></div>' +
      '<div class="wk-reader__stage">' +
      '<button type="button" class="wk-reader__nav" data-step="-1" aria-label="Poprzednia strona">‹</button>' +
      '<div class="wk-reader__book"></div>' +
      '<button type="button" class="wk-reader__nav" data-step="1" aria-label="Następna strona">›</button>' +
      '<div class="wk-reader__loading">Wczytuję fragment…</div></div>' +
      '<div class="wk-reader__status" aria-live="polite"></div>';
    document.body.appendChild(reader);
    reader.querySelector('.wk-reader__close').addEventListener('click', close);
    reader.addEventListener('click', function (e) {
      var n = e.target.closest('[data-step]');
      if (n) go(+n.getAttribute('data-step'));
      else if (e.target === reader || e.target.classList.contains('wk-reader__stage')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!state || reader.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    });
    var x0 = null;
    reader.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    reader.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      x0 = null;
    });
    window.addEventListener('resize', function () { if (state && state.pdf && !reader.hidden) layout(); });
    return reader;
  }

  // strona PDF → obrazek (pamiętany)
  function pageImg(i) {
    if (!state || i < 1 || i > state.n) return Promise.resolve(null);
    if (state.cache[i]) return state.cache[i];
    state.cache[i] = state.pdf.getPage(i).then(function (page) {
      var vp1 = page.getViewport({ scale: 1 });
      var scale = Math.min(2.2, (state.pageH * (window.devicePixelRatio || 1)) / vp1.height);
      var vp = page.getViewport({ scale: scale });
      var c = document.createElement('canvas');
      c.width = Math.round(vp.width); c.height = Math.round(vp.height);
      return page.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise.then(function () {
        return c.toDataURL('image/jpeg', 0.9);
      });
    });
    return state.cache[i];
  }

  function pageEl(i, cls) {
    var p = el('div', 'wk-reader__page ' + (cls || ''));
    if (!i || i > state.n) { p.classList.add('is-empty'); return p; }
    pageImg(i).then(function (src) {
      if (!src) return;
      var im = new Image(); im.alt = 'Strona ' + i; im.src = src; p.appendChild(im);
    });
    return p;
  }

  // rozkładówki: 0 = sama pierwsza strona po prawej, potem (2,3), (4,5)…; telefon: po jednej stronie
  function spreadPages(k) {
    if (state.single) return [null, k + 1];
    return k === 0 ? [null, 1] : [2 * k, 2 * k + 1];
  }
  function spreads() { return state.single ? state.n : 1 + Math.ceil((state.n - 1) / 2); }

  function layout() {
    var stage = reader.querySelector('.wk-reader__stage');
    var bookEl = reader.querySelector('.wk-reader__book');
    state.single = MOBILE.matches;
    var navW = reader.querySelector('.wk-reader__nav').offsetWidth * 2 + 40;
    var availW = stage.clientWidth - navW, availH = stage.clientHeight - 20;
    var pages = state.single ? 1 : 2;
    state.pageH = Math.floor(Math.min(availH, (availW / pages) / state.ar));
    bookEl.style.height = state.pageH + 'px';
    bookEl.style.setProperty('--ar', state.ar);
    if (state.k >= spreads()) state.k = spreads() - 1;
    render();
  }

  function render() {
    var bookEl = reader.querySelector('.wk-reader__book');
    var pp = spreadPages(state.k);
    bookEl.innerHTML = '';
    if (!state.single) bookEl.appendChild(pageEl(pp[0], 'wk-reader__page--l'));
    bookEl.appendChild(pageEl(pp[1], state.single ? '' : 'wk-reader__page--r'));
    var shown = pp.filter(function (x) { return x && x <= state.n; });
    reader.querySelector('.wk-reader__status').textContent =
      (shown.length > 1 ? 'Strony ' + shown[0] + '–' + shown[1] : 'Strona ' + shown[0]) + ' z ' + state.n;
    reader.querySelector('[data-step="-1"]').disabled = state.k === 0;
    reader.querySelector('[data-step="1"]').disabled = state.k >= spreads() - 1;
    // wczytaj z wyprzedzeniem następną rozkładówkę
    var nx = spreadPages(Math.min(spreads() - 1, state.k + 1));
    pageImg(nx[0]); pageImg(nx[1]);
  }

  function go(step) {
    if (!state || state.busy) return;
    var k2 = state.k + step;
    if (k2 < 0 || k2 >= spreads()) return;
    if (state.single || REDUCED) { state.k = k2; render(); return; }
    // kartka obraca się wokół grzbietu: front = obecna strona, tył = strona z następnej rozkładówki
    state.busy = true;
    var bookEl = reader.querySelector('.wk-reader__book');
    var cur = spreadPages(state.k), nxt = spreadPages(k2);
    var leaf = el('div', 'wk-reader__leaf ' + (step > 0 ? 'wk-reader__leaf--next' : 'wk-reader__leaf--prev'));
    if (step > 0) {
      leaf.appendChild(pageEl(cur[1], 'wk-reader__page--r'));
      leaf.appendChild(pageEl(nxt[0], 'wk-reader__page--l is-back'));
      bookEl.children[1].replaceWith(pageEl(nxt[1], 'wk-reader__page--r'));
    } else {
      leaf.appendChild(pageEl(cur[0], 'wk-reader__page--l'));
      leaf.appendChild(pageEl(nxt[1], 'wk-reader__page--r is-back'));
      bookEl.children[0].replaceWith(pageEl(nxt[0], 'wk-reader__page--l'));
    }
    bookEl.appendChild(leaf);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { leaf.style.transform = 'rotateY(' + (step > 0 ? -180 : 180) + 'deg)'; });
    });
    setTimeout(function () { state.k = k2; state.busy = false; render(); }, 720);
  }

  function open(btn) {
    ensureReader();
    var url = btn.getAttribute('data-pdf');
    state = { url: url, k: 0, n: 0, ar: 0.7, cache: {}, busy: false, trigger: btn };
    reader.querySelector('.wk-reader__title').innerHTML = (btn.getAttribute('data-title') || '') + '<small>fragment</small>';
    reader.querySelector('.wk-reader__dl').href = url;
    reader.querySelector('.wk-reader__book').innerHTML = '';
    reader.querySelector('.wk-reader__status').textContent = '';
    var loading = reader.querySelector('.wk-reader__loading');
    loading.hidden = false;
    loading.textContent = 'Wczytuję fragment…';
    reader.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { reader.classList.add('is-open'); });
    reader.querySelector('.wk-reader__close').focus({ preventScroll: true });
    loadPdfjs().then(function (lib) {
      return lib.getDocument({ url: url }).promise;
    }).then(function (pdf) {
      if (!state || state.url !== url) return;
      state.pdf = pdf; state.n = pdf.numPages;
      return pdf.getPage(1).then(function (p) {
        var vp = p.getViewport({ scale: 1 });
        state.ar = vp.width / vp.height;
        loading.hidden = true;
        layout();
      });
    }).catch(function () {
      loading.innerHTML = 'Nie udało się wczytać fragmentu. <a href="' + url + '" target="_blank" rel="noopener" style="color:#fff">Otwórz PDF</a>';
    });
  }

  function close() {
    if (!reader || reader.hidden) return;
    reader.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var t = state && state.trigger;
    state = null;
    setTimeout(function () { reader.hidden = true; }, 250);
    if (t) t.focus({ preventScroll: true });
  }

  /* ---------- „Posłuchaj fragmentu” – przycisk jest odtwarzaczem ---------- */

  var playing = null;

  function fmt(sec) {
    if (!isFinite(sec)) return '';
    sec = Math.round(sec);
    return Math.floor(sec / 60) + ':' + ('0' + (sec % 60)).slice(-2);
  }

  function initPlay(btn) {
    if (btn.__wk) return;
    btn.__wk = true;
    var audio = new Audio();
    audio.preload = 'metadata';
    audio.src = btn.getAttribute('data-mp3');
    var time = btn.querySelector('.wk-play__time');
    var bar = btn.querySelector('.wk-play__bar i');
    var label = btn.querySelector('.wk-play__label');
    var base = label ? label.textContent : '';
    function show() {
      var d = audio.duration, c = audio.currentTime;
      if (time) time.textContent = audio.paused && !c ? fmt(d) : fmt(c) + ' / ' + fmt(d);
      if (bar) bar.style.width = d ? (100 * c / d) + '%' : '0';
      btn.classList.toggle('has-progress', c > 0);
    }
    function state(on) {
      btn.classList.toggle('is-playing', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (label) label.textContent = on ? 'Słuchasz fragmentu' : base;
    }
    audio.addEventListener('loadedmetadata', show);
    audio.addEventListener('timeupdate', show);
    audio.addEventListener('pause', function () { state(false); show(); });
    audio.addEventListener('play', function () { state(true); });
    audio.addEventListener('ended', function () { audio.currentTime = 0; state(false); show(); });
    btn.addEventListener('click', function () {
      if (audio.paused) {
        if (playing && playing !== audio) playing.pause();
        playing = audio;
        audio.play();
      } else {
        audio.pause();
      }
    });
  }

  /* ---------- opis: szczegóły książki pod opisem, rozwijane sekcje ---------- */

  var DETAIL_ORDER = ['Oprawa', 'Liczba stron', 'Format', 'Rok wydania', 'ISBN', 'Wydawnictwo'];

  // motyw nadaje części elementom (np. <hr>) display, który wygrywa z atrybutem hidden
  function hide(n) {
    n.__hidden = true;
    n.hidden = true;
    n.style.setProperty('display', 'none', 'important');
  }

  function initDescription(root) {
    var desc = root.querySelector('.product__block--description');
    if (!desc || desc.__wk) return;
    desc.__wk = true;
    var box = desc.querySelector('.product-description-container') || desc;
    var hasTools = !!root.querySelector('.wk-peek');
    markQuote(box);

    // podział na części według nagłówków; ramka z nagłówkiem w środku też zaczyna część
    function headingOf(n) {
      if (/^H[2-5]$/.test(n.tagName)) return n;
      if (n.tagName === 'DIV') { var h = n.querySelector(':scope > h2, :scope > h3, :scope > h4, :scope > h5'); if (h && n.firstElementChild === h) return h; }
      return null;
    }
    var parts = [], cur = null;
    Array.prototype.slice.call(box.children).forEach(function (n) {
      var h = headingOf(n);
      if (h || !cur) { cur = { h: h, title: h ? h.textContent.trim().replace(/:$/, '') : '', nodes: [] }; parts.push(cur); }
      cur.nodes.push(n);
    });
    if (parts.length < 2) return;

    parts.forEach(function (part, idx) {
      var t = part.title.toLowerCase();
      var all = part.nodes;
      var hasFragments = all.some(function (n) { return n.querySelector && n.querySelector('a[href*=".pdf"], iframe[src*="podbean"]'); });
      // 1) parametry techniczne → „Szczegóły książki” przy cenie
      if (/parametry|szczegóły techniczne|dane techniczne/.test(t)) {
        if (buildDetails(all[0], tableRows(all))) all.forEach(function (n) { hide(n); });
        return;
      }
      // 2) ramka z fragmentem PDF / audio – są już przy książce
      if (hasTools && hasFragments && idx > 0) { all.forEach(function (n) { hide(n); }); return; }
      // 3) długie części (spis treści, FAQ) zwijamy
      if (idx > 0 && /spis treści|pytania|faq/.test(t)) {
        var d = document.createElement('details');
        d.className = 'wk-sekcja';
        var sum = document.createElement('summary');
        sum.textContent = part.title;
        d.appendChild(sum);
        var body = document.createElement('div');
        body.className = 'wk-sekcja__body';
        all[0].parentNode.insertBefore(d, all[0]);
        all.forEach(function (n) { if (n !== part.h) body.appendChild(n); else n.remove(); });
        d.appendChild(body);
      }
    });

    // separatory <hr> po ukrytych częściach: chowamy te przed ramką szczegółów, sekcją zwijaną, kolejną linią i na końcu
    function nextVisible(n) { n = n.nextElementSibling; while (n && n.__hidden) n = n.nextElementSibling; return n; }
    Array.prototype.forEach.call(box.querySelectorAll(':scope > hr'), function (hr) {
      var nv = nextVisible(hr);
      if (!nv || nv.tagName === 'HR' || nv.classList.contains('wk-sekcja') || nv.classList.contains('wk-details')) hide(hr);
    });
  }

  // cytat promujący na początku opisu: wyśrodkowany akapit zaczynający się cudzysłowem (wśród pierwszych 3 elementów,
  // bo przed nim bywa ramka „Zapowiedź”) → wyróżniony cytat; podpis po kresce („– magazyn Velo”) osobno
  function markQuote(box) {
    var kids = Array.prototype.slice.call(box.children, 0, 3);
    kids.some(function (q) {
      if (q.tagName !== 'P') return false;
      var centered = (q.getAttribute('style') || '').replace(/\s/g, '').indexOf('text-align:center') >= 0;
      if (!centered || !/^[„"“»]/.test(q.textContent.trim())) return true;   // pierwszy akapit nie jest cytatem – koniec
      q.classList.add('wk-cytat');
      Array.prototype.forEach.call(q.children, function (c) {
        if (/^[–—-]\s/.test(c.textContent.trim()) && c.tagName !== 'EM') c.classList.add('wk-cytat__autor');
      });
      return true;
    });
  }

  // wiersze tabel z opisu: { Oprawa: 'Twarda', 'Liczba stron': '200', … }
  function tableRows(nodes) {
    var rows = {};
    nodes.forEach(function (n) {
      Array.prototype.forEach.call(n.querySelectorAll ? n.querySelectorAll('tr') : [], function (tr) {
        var c = tr.querySelectorAll('td, th');
        if (c.length >= 2) rows[c[0].textContent.trim().replace(/:$/, '')] = c[1].textContent.trim();
      });
    });
    return rows;
  }

  function detailsList(rows, keys) {
    var items = keys.filter(function (k) { return rows[k]; });
    if (!items.length) return null;
    var dl = document.createElement('dl');
    dl.className = 'wk-details';
    dl.setAttribute('aria-label', 'Szczegóły książki');
    dl.innerHTML = items.map(function (k) {
      return '<div><dt>' + k + '</dt><dd>' + rows[k].replace(/</g, '&lt;') + '</dd></div>';
    }).join('');
    return dl;
  }

  // ramka „Szczegóły książki” w miejscu tabeli parametrów: pod opisem, nad spisem treści i FAQ
  function buildDetails(before, rows) {
    var dl = detailsList(rows, DETAIL_ORDER);
    if (!dl || !before || !before.parentNode) return false;
    before.parentNode.insertBefore(dl, before);
    return true;
  }

  /* ---------- okienko podglądu (półki na stronie głównej): krótki opis ---------- */

  var SHORT_LEN = 450;                  // znaków opisu w okienku, bez cytatu i nagłówków
  var SHORT_STOP = /parametry|szczegóły|dane techniczne|spis treści|pytania|faq|fragment|posłuchaj|zajrzyj/;
  var DATA_LINE = /^(autor|autorzy|tytuł oryginału|tytuł|wydawnictwo|wydawca|liczba stron|ilość stron|oprawa|format|wymiary|isbn|rok wydania|data wydania|tłumaczenie|tłumacz|przekład)\s*:/i;
  var ROW_NAME = { 'ilość stron': 'Liczba stron', 'wymiary': 'Format' };

  // dane z wierszy „Oprawa: miękka” w akapitach – opisy innych wydawnictw bywają bez tabeli
  function lineRows(box, rows) {
    Array.prototype.forEach.call(box.querySelectorAll('p, li'), function (p) {
      p.innerHTML.split(/<br\s*\/?>/i).forEach(function (line) {
        var t = document.createElement('template');
        t.innerHTML = line;
        var txt = t.content.textContent.replace(/\s+/g, ' ').trim(), m = txt.match(DATA_LINE);
        if (!m) return;
        var key = m[1].toLowerCase(), name = ROW_NAME[key] || key.charAt(0).toUpperCase() + key.slice(1);
        var val = txt.slice(m[0].length).trim();
        if (val && !rows[name]) rows[name] = val;
      });
    });
    return rows;
  }

  // opis w okienku: cytat, początek opisu (listy przycięte) i Oprawa / Liczba stron / Format; reszta na karcie produktu.
  // root jest jeszcze poza stroną (zawartość <template>), więc ramki odtwarzaczy i obrazki z opisu się nie wczytują.
  function shorten(root) {
    var box = root.querySelector('.product-description-container') || root;
    while (box.children.length === 1 && box.firstElementChild.tagName === 'DIV') box = box.firstElementChild;
    markQuote(box);
    var rows = lineRows(box, tableRows([box]));
    var len = 0, stop = false;
    Array.prototype.slice.call(box.children).forEach(function (n) {
      var t = n.textContent.replace(/\s+/g, ' ').trim();
      var head = /^H[2-6]$/.test(n.tagName), quote = n.classList.contains('wk-cytat');
      if (head && SHORT_STOP.test(t.toLowerCase())) stop = true;
      var keep = !stop && t && !DATA_LINE.test(t) && !n.querySelector('iframe, table, img, a[href*=".pdf"]') &&
        (quote || head || /^(P|UL|OL)$/.test(n.tagName) ||
         (n.tagName === 'DIV' && t.length < 220 && !n.querySelector('h2, h3, h4, h5, h6')));   // np. ramka „Premiera…”
      if (keep && !quote && !head && len >= SHORT_LEN) { stop = true; keep = false; }
      if (!keep) { n.remove(); return; }
      if (/^(UL|OL)$/.test(n.tagName)) {
        Array.prototype.slice.call(n.children).forEach(function (li) {
          if (len >= SHORT_LEN) li.remove(); else len += li.textContent.length;
        });
      } else if (!quote && !head) {
        len += t.length;
      }
    });
    // bez wiszącego nagłówka albo zapowiedzi listy („Dzięki tej książce dowiesz się:”) na końcu
    var last;
    while ((last = box.lastElementChild) && (/^H[2-6]$/.test(last.tagName) || /:$/.test(last.textContent.trim()))) last.remove();
    var dl = detailsList(rows, ['Oprawa', 'Liczba stron', 'Format']);
    if (dl) box.appendChild(dl);
  }

  function initAll(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('.wk-k3d'), initBook);
    Array.prototype.forEach.call(s.querySelectorAll('.wk-peek__btn[data-pdf]'), function (b) {
      if (b.__wk) return;
      b.__wk = true;
      b.addEventListener('click', function () { open(b); });
    });
    Array.prototype.forEach.call(s.querySelectorAll('.wk-play[data-mp3]'), initPlay);
    // główny produkt (nie podgląd w szufladzie): uporządkowany opis
    var main = s.querySelector('[id$="__main"] product-info, product-info[id*="__main"], [id$="__main"]');
    if (main) initDescription(main);
  }

  window.wkKsiazka = {
    init: initAll,
    shorten: shorten,
    stop: function () { if (playing) playing.pause(); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
